/* =============================================================================
   SAYBEAM ADVERTORIAL — INTERACTIONS
   Recreated 1:1 from the original inline script on saybeam.com/pages/adv-3.

   Two behaviours only:
     A. Countdown timer inside .adv-offer — starts at the value of
        data-countdown-minutes (59) and ticks down MM:SS once per second.
        It is NOT persisted: it restarts on every page load / refresh.
     B. Sticky bottom CTA bar — hidden until the visitor has scrolled past
        15% of the page, and auto-hidden again whenever any real CTA button
        is inside the lower part of the viewport (so the bar never covers
        the button the reader is about to click).

   The FAQ needs no JavaScript: it uses native <details>/<summary>.
   ============================================================================= */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------------
     A. COUNTDOWN TIMER
  ---------------------------------------------------------------------------- */
  var offer = document.querySelector('.adv-offer[data-countdown-minutes]');

  if (offer) {
    var timerEl = offer.querySelector('.timer');
    var minutes = parseInt(offer.getAttribute('data-countdown-minutes') || '59', 10);
    var endTime = Date.now() + minutes * 60 * 1000;
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var remaining = Math.max(0, endTime - Date.now());

      var mm = Math.floor(remaining / 60000);
      remaining -= mm * 60000;
      var ss = Math.floor(remaining / 1000);

      if (timerEl) {
        timerEl.textContent = pad(mm) + ':' + pad(ss);
      }

      if (endTime - Date.now() <= 0) {
        clearInterval(interval);
      }
    }

    tick();                              // paint immediately, no 1s blank
    interval = setInterval(tick, 1000);
  }


  /* ---------------------------------------------------------------------------
     B. STICKY BOTTOM CTA BAR
  ---------------------------------------------------------------------------- */
  var sticky = document.getElementById('advSticky');
  if (!sticky) return;

  function onScroll() {
    var scrolled = window.scrollY || document.documentElement.scrollTop || 0;
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    var percent = scrollable > 0 ? (scrolled / scrollable) * 100 : 0;

    // Below 15% of the page: keep the bar off-screen.
    if (percent < 15) {
      sticky.classList.remove('visible');
      return;
    }

    // Hide the bar while an on-page CTA sits in the bottom band of the viewport.
    var show = true;
    var ctas = document.querySelectorAll('.adv-cta, .adv-offer-cta, .adv-cta-mini');
    var vh = window.innerHeight;

    for (var i = 0; i < ctas.length; i++) {
      var r = ctas[i].getBoundingClientRect();
      if (r.top < vh - 60 && r.bottom > vh - 180) {
        show = false;
        break;
      }
    }

    sticky.classList.toggle('visible', show);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();                            // set correct state on first paint
})();
